import Topbar from '@shared/components/navigation/nav-bars/topbar';
import { html, nothing } from '@shared/utils/rendering/html';
import TopbarConfig from '../configs/navigation/topbar.config';
import Sidebar from '@shared/components/navigation/nav-bars/sidebar';
import { useAuth } from '../utils/context/auth-context';
import { useMemo } from 'preact/hooks';
import { GenerateUserAccountConfig } from '../configs/navigation/user.config';
import { GenerateSidebarConfig } from '../configs/navigation/sidebar.config';
import { SystemKeys } from '../constants/security/systems.constants';
import { isProduction } from '../constants/utility/env.constants';
import { useFeatureChecks } from '../utils/features/feature-context';
import { useLocation } from 'preact-iso';

const AppLayout = ({ children, ...props }) => {
    const { logout, user } = useAuth();
    const { map: featureMap } = useFeatureChecks();
    const { route } = useLocation();

    const systemCheck = useMemo(() => {
        return (system, fallback) => {
            const key = SystemKeys[system];
            if (!key) return fallback;

            return Object.prototype.hasOwnProperty.call(featureMap, key)
                ? Boolean(featureMap[key])
                : fallback;
        };
    }, [featureMap]);

    const userOptions = useMemo(() => {
        if (logout) {
            const config = GenerateUserAccountConfig(logout, user);
            return config;
        }
    }, [logout, user]);

    const SidebarConfig = useMemo(() => {
        if (user) {
            return GenerateSidebarConfig(user, { featureCheck: systemCheck });
        }
        return null;
    }, [systemCheck, user]);
    const isNonProduction = !isProduction();

    return userOptions && SidebarConfig
        ? html`
              <div id="app-container" ...${props}>
                  <${Topbar}
                      class=${isNonProduction ? 'non-production' : undefined}
                      settings=${{ ...TopbarConfig, account: userOptions }}
                  />
                  <${Sidebar} settings=${SidebarConfig} onNavigate=${route} />
                  <div id="content">${children}</div>
                  <div id="footer"></div>
              </div>
          `
        : nothing;
};

export default AppLayout;
